import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-unsubscription',
  templateUrl: './unsubscription.component.html',
  styleUrls: ['./unsubscription.component.scss']
})
export class UnsubscriptionComponent implements OnInit {

  constructor(
    private userService: UserService,
    private authService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  unsubcribe(): void {
    this.userService.unsubscribe().subscribe(() => {
      this.router.navigate(['/profil/unsubscribe']);
      this.authService.logout();
    });
  }
}
